import { render, staticRenderFns } from "./rubycon.vue?vue&type=template&id=1634a8ac"
import script from "./rubycon.vue?vue&type=script&lang=js"
export * from "./rubycon.vue?vue&type=script&lang=js"
import style0 from "./rubycon.vue?vue&type=style&index=0&id=1634a8ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports